<template>
    <PersonalInfoPolicy20260226Content />
</template>

<script>
import PersonalInfoPolicy20260226Content from '@/views/policy/common/PersonalInfoPolicy20260226Content.vue';

export default {
    name: 'PrivacyPolicy20260226',
    components: {
        PersonalInfoPolicy20260226Content,
    },
};
</script>
